import React from 'react'

import {
  createColumnHelper,
  getCoreRowModel,
  useReactTable,
} from '@tanstack/react-table'
import { useTranslation } from 'react-i18next'

import { Box, DataTable, Stack, Text } from '@enechain/ecloud-designsystem'

import { getTextAlignLightTableStyle } from '../../../common/DataTable/styleHelper'
import { FeeResultModel } from '../models/FeeResultModel'

type Props = {
  feeResults: FeeResultModel[] | undefined
}

const resultFeeTable: React.FC<Props> = ({ feeResults }) => {
  const { t } = useTranslation(['component', 'common', 'domain'])
  const columnHelper = createColumnHelper<FeeResultModel>()

  const columns = [
    columnHelper.accessor('orderNumber', {
      header: t('component:features.order_simulation.order_relation_number'),
      cell: (info) => <Box>{info.getValue()}</Box>,
      enableSorting: false,
    }),
    columnHelper.accessor('orderSummary', {
      header: t('component:features.order_simulation.order_summary_text'),
      cell: (info) => {
        return <Text>{info.getValue()}</Text>
      },
      enableSorting: false,
    }),
    columnHelper.accessor('fee', {
      header: () => (
        <Text css={{ textTransform: 'none' }}>
          {t('component:features.order_simulation.fee')}
        </Text>
      ),
      cell: (info) =>
        info.row.original.isFeeHidden ? (
          <Text>{t('component:features.order_simulation.fee_hidden')}</Text>
        ) : (
          <Text>{info.getValue()}</Text>
        ),
      enableSorting: false,
      meta: getTextAlignLightTableStyle(),
    }),
  ]

  const table = useReactTable({
    columns,
    data: feeResults ?? [],
    getCoreRowModel: getCoreRowModel(),
  })

  if (feeResults === undefined) {
    return null
  }

  return (
    <Stack>
      <DataTable
        table={table}
        emptyComponent={
          <Box width="100%" textAlign="center">
            {t('common:error.empty_data')}
          </Box>
        }
      />
    </Stack>
  )
}

export const ResultFeeTable = React.memo(resultFeeTable)
